import {
  Alert,
  Button,
  Container,
  Paper,
  Snackbar,
  Typography
} from '@mui/material';
import { Precinct, Voter } from '../../types';
import React, { useEffect, useState } from 'react';
import { collection, deleteDoc, doc, getCountFromServer, getDocs, query, setDoc, where } from 'firebase/firestore';

import { db } from '../../firebase';
import { removeIndexesOf } from '../../utils/indexer';
import { useAuth } from '../../hooks/useAuth';

const UpdateVoterCount: React.FC = () => {
  const { user } = useAuth();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');
  const [precincts, setPrecincts] = useState<Precinct[]>([]);

  useEffect(() => {
    const fetchPrecincts = async () => {
      try {
        const precinctsColRef = collection(db, "precincts");
        const q = query(precinctsColRef,
          where("province", "==", "SURIGAO DEL NORTE"),
          where("city_municipality", "==", "SANTA MONICA"),
          // where("barangay", "==", barangay)
        );
        const precinctDocsSnap = await getDocs(q);
        const _precincts = precinctDocsSnap.docs.map((d) => d.data() as Precinct);
        setPrecincts(_precincts);
      } catch (error) {
        console.error("Error fetching barangays:", error);
      }
    };

    fetchPrecincts();
  }, []);

  const updatePrecinctVoterCountFunc = async (precinct: Precinct) => {
    const votersColRef = collection(db, "voters");
    const q = query(votersColRef,
      where("province", "==", precinct.province),
      where("city_municipality", "==", precinct.city_municipality),
      where("barangay", "==", precinct.barangay),
      where("precinct", "==", precinct.precinct)
    );
    const snapshot = await getCountFromServer(q);
    const count = snapshot.data().count;

    const dashboard_id = "SURIGAO DEL NORTE_DISTRICT 1";
    const precinct_tab_doc_path = `tabulationsV2/${dashboard_id}/`
      + `regions/${precinct.region}/provinces/${precinct.province}/`
      + `districts/${precinct.district}/cities/${precinct.city_municipality}/`
      + `barangays/${precinct.barangay}/precincts/${precinct.precinct}`;
    
    console.log(`tab_doc_path: ${precinct_tab_doc_path}, count: ${count}`);
    const tabDocRef = doc(db, precinct_tab_doc_path);
    await setDoc(tabDocRef, { totalVoters: count }, { merge: true });
  };

  const cleanup = async () => {
    const colRef = collection(db, "indexesV2/voter/fields/name/keywords");
    const q = query(colRef,
      where("entriesCount", "==", 0),
    );
    const snapshot = await getDocs(q);
    const docsToDelete = snapshot.docs.map((doc) => doc.ref);
    for (const docRef of docsToDelete) {
      const documentPath = docRef.path;
      console.log(`Deleting doc: ${documentPath}`);

      // await removeIndexesOf("voter", "name", documentPath);
      await deleteDoc(docRef);
    }
  };

  const handleUpdateVoterCount = async () => {
    if (!user) {
      setSnackbarMessage('You must be logged in to perform this action');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    try {
      // debugger;
      // await cleanup();

      // iterate over precincts
      await Promise.all(precincts.map(async (precinct) => {
        return await updatePrecinctVoterCountFunc(precinct);
      }));
      console.log('Precinct voter count updated successfully');

      setSnackbarMessage('Precinct voter count updated successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);      
    } catch (error) {
      console.error('Error updating precinct voter count:', error);
      setSnackbarMessage('Failed to update precinct voter count');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Update Precinct Voter Count
        </Typography>

        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleUpdateVoterCount}
          fullWidth
        >
          Update Voter Count
        </Button>

        <Snackbar 
          open={snackbarOpen} 
          autoHideDuration={6000} 
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert 
            onClose={handleSnackbarClose} 
            severity={snackbarSeverity} 
            sx={{ width: '100%' }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
};

export default UpdateVoterCount;
